import React, { useState, FC, useEffect, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import ListingsToolbar from './ListingsToolbar';
import ProductList from './ProductList';
import { Filters } from './types';
import { Container, Box, CircularProgress, Typography, Paper } from '@mui/material';
import { ActiveListingsResponse } from '../../graphql/generated';
import { GET_ACTIVE_LISTINGS } from '../../graphql/queries';

const BrowseListingsPage: FC = () => {
  const [filters, setFilters] = useState<Filters>({});

  const { data, loading, error, refetch } = useQuery<{ activeListings: ActiveListingsResponse }>(
    GET_ACTIVE_LISTINGS,
    {
      variables: filters,
      notifyOnNetworkStatusChange: true,
    }
  );

  const handleFiltersSubmit = useCallback((newFilters: Filters) => {
    setFilters(newFilters); // Update filters with sort order
  }, []);

  useEffect(() => {
    refetch(filters); // Refetch data when filters change
  }, [filters, refetch]);

  return (
    <Container maxWidth="lg" id='BrowseListingContainer' sx={{ backgroundColor: '#f5f5f5', padding: 0, borderRadius: 16 }} style={{borderRadius: 16}}>

      <Box mt={4} p={2} sx={{ borderRadius: '16px' }}>
        <Paper elevation={3} sx={{ borderRadius: '16px' }}>
          <ListingsToolbar onFiltersSubmit={handleFiltersSubmit} listingsSummary={data?.activeListings.listingsSummary || {brands: [], sizes: []}} />
          {loading ? (
            <Box display="flex" justifyContent="center" marginTop={4}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error">Error: {error.message}</Typography>
          ) : (
            <ProductList products={data?.activeListings.listings || []} />
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default BrowseListingsPage;
